var _circle, _circle2, _circle3, _circle4, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 2,
    r: 2,
    fill: "#034781"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0002,
    cy: 22,
    r: 2,
    fill: "#034781"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 22,
    r: 2,
    fill: "#034781"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#034781"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.46118,
    y: 0.63258,
    width: 28.1959,
    height: 4,
    transform: "rotate(45 3.46118 0.63258)",
    fill: "#034781"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3987,
    y: 3.42993,
    width: 28.2401,
    height: 4,
    transform: "rotate(135 23.3987 3.42993)",
    fill: "#034781"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMenuClose);
export default __webpack_public_path__ + "static/media/picto_menu_close.35f3695bef1d55d646cff641a56a9d2f.svg";
export { ForwardRef as ReactComponent };